import React from 'react';

import PropTypes from 'prop-types';

import { useCurrentProductId } from '@adsk/alloy-provider';
import { useLocale } from '@adsk/alloy-react-locale';

import {
  StyledPackagesEntityBlock,
  StyledPackagesEntityBlockContent,
  StyledPackageEntityBlockTitle,
  StyledBlockRemoveButtonWrapper,
  StyledPackagesEntityBlockDetail,
  StyledPackagesEntityBlockDescription,
  StyledDivider,
  StyledPackageEntityBlockResourceCount,
} from './PackagesEntityBlock.styles';
import BlockRemoveButton from '../../../BlockRemoveButton';
import getPackageDetailUrl from '../helpers/getPackageDetailUrl';

const PackagesEntityBlock = ({
  entity,
  projectId,
  onRemoveClick,
  onReferenceClickAnalytics,
}) => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));
  const productId = useCurrentProductId();

  return (
    <StyledPackagesEntityBlock
      onClick={onReferenceClickAnalytics}
      href={getPackageDetailUrl(projectId, productId, entity.id)}
    >
      <StyledPackagesEntityBlockContent>
        <StyledPackageEntityBlockTitle>
          {T.translate('PACKAGE_ID_AND_NAME', {
            displayId: entity.displayId,
            name: entity.name,
          })}
        </StyledPackageEntityBlockTitle>
        <StyledPackagesEntityBlockDetail>
          {entity.description && (
            <StyledPackagesEntityBlockDescription>
              {entity.description}
            </StyledPackagesEntityBlockDescription>
          )}
          {entity.description && <StyledDivider />}
          <StyledPackageEntityBlockResourceCount>
            {T.translate('TOTAL_FILES', { context: entity.resourceCount })}
          </StyledPackageEntityBlockResourceCount>
        </StyledPackagesEntityBlockDetail>
      </StyledPackagesEntityBlockContent>
      <StyledBlockRemoveButtonWrapper>
        <BlockRemoveButton onClick={onRemoveClick} />
      </StyledBlockRemoveButtonWrapper>
    </StyledPackagesEntityBlock>
  );
};

PackagesEntityBlock.propTypes = {
  entity: PropTypes.object,
  projectId: PropTypes.string,
  onReferenceClickAnalytics: PropTypes.func,
  onRemoveClick: PropTypes.func,
};

export default PackagesEntityBlock;
